module.exports = __webpack_public_path__ + "img/icon_submenu6.29d7bf46.svg";